<ng-container *ngIf="{ transactionalDataState: transactionalDataState$ | async, sharedDataState: sharedDataState$ | async } as states">
    <div class="production-container mat-elevation-z8">
        <div class="table-header">

            <mat-form-field style="width: 20%" subscriptSizing="dynamic">
                <mat-label>{{ "app.external-data.daterange.label" | translate }}</mat-label>
                <mat-date-range-input [formGroup]="dateFilterFormGroup" [rangePicker]="picker">
                    <input matStartDate formControlName="start">
                    <input matEndDate formControlName="end">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic">
                <input matInput [formControl]="searchFormControl" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="searchFormControl.value != ''"
                        (click)="searchFormControl.setValue('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="states.transactionalDataState.isLoading || states.sharedDataState.isLoading
        ? 'visible'
        : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">

            <table mat-table matSort [dataSource]="dataSource" matSortActive="date" matSortDirection="asc">

                <ng-container matColumnDef="productionOrderNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.production-order.nr.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.productionOrderNr }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="articleNrs">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.production-order.articleNrs.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element.exit | filter : 'costUnitId' : null: 'not-equals' as costUnitExits">
                            <ng-container *ngFor="let exitProduction of costUnitExits; let i = index">
                                <ng-container *ngIf="(exitProduction | as : IProduction).costUnitId as costUnitId">
                                    <ng-container *ngIf="states.sharedDataState.costUnitLookup[costUnitId] as costUnit">
                                        {{ costUnit.articleNr }}
                                    </ng-container>
                                    <ng-container *ngIf="i + 1 !== costUnitExits.length"><br></ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="costUnits">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.production-order.cost-units.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element.exit | filter : 'costUnitId' : null: 'not-equals' as costUnitExits">
                            <ng-container *ngFor="let exitProduction of costUnitExits; let i = index">
                                <ng-container *ngIf="(exitProduction | as : IProduction).costUnitId as costUnitId">
                                    <ng-container *ngIf="states.sharedDataState.costUnitLookup[costUnitId] as costUnit">
                                        {{ costUnit.name }}
                                    </ng-container>
                                    <ng-container *ngIf="i + 1 !== costUnitExits.length"><br></ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.production-order.date.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.date | date : 'dd.MM.yyyy' }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="layout.columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: layout.columns;" (click)="openProductionOrder(row)"></tr>

            </table>
            <mat-paginator showFirstLastButtons [pageSizeOptions]="[20, 50]"></mat-paginator>
        </div>
    </div>
</ng-container>
